import React from 'react';
import cx from 'classnames';
import Typography from '@primitives/Typography';
import { KeyValueLabelProps } from './types';
import styles from './KeyValueLabel.module.scss';

const KeyValueLabel: React.FC<KeyValueLabelProps> = ({ dataArray = [], className = '', style }) => {
    return (
        <div
            className={cx(styles['key-value-wrapper'], className)}
            style={style}
            data-testid="wrapper"
        >
            {dataArray.map((row) => {
                const {
                    key,
                    value,
                    rowClassName = '',
                    keyClassName = '',
                    valueClassName = '',
                } = row;
                return (
                    <div
                        className={cx(styles['key-value-row'], rowClassName)}
                        key={key}
                        data-testid="row"
                    >
                        <Typography
                            variant="p3"
                            as="span"
                            className={cx(styles['key-text'], keyClassName)}
                        >
                            {key}
                        </Typography>
                        <Typography
                            variant="h4"
                            as="span"
                            className={cx(styles['value-text'], valueClassName)}
                        >
                            {value}
                        </Typography>
                    </div>
                );
            })}
        </div>
    );
};

export default KeyValueLabel;
